import { FC, Fragment } from 'react';
import { List, ListProps } from '@mui/material';
import TableOfContentsEntry, {
  TableOfContentsMenuEntry,
} from './TableOfContentsEntry';

export type NestedTableOfContentsMenuEntry = TableOfContentsMenuEntry & {
  subEntries?: Array<TableOfContentsMenuEntry>;
};

type Props = {
  entries: Array<NestedTableOfContentsMenuEntry>;
  selectedId: string;
  menuProps?: ListProps;
  onEntrySelect: (id: string) => void;
};

const NestedTableOfContentsMenu: FC<Props> = ({
  entries,
  selectedId,
  menuProps,
  onEntrySelect,
}) => (
  <List disablePadding {...menuProps}>
    {entries.map((entry) => (
      <Fragment key={entry.id}>
        <TableOfContentsEntry
          entry={entry}
          selected={selectedId === entry.id}
          onSelect={onEntrySelect}
        />
        {entry.subEntries?.map((subEntry) => (
          <TableOfContentsEntry
            key={subEntry.id}
            entry={subEntry}
            selected={selectedId === subEntry.id}
            onSelect={onEntrySelect}
          />
        ))}
      </Fragment>
    ))}
  </List>
);

export default NestedTableOfContentsMenu;
